import React from 'react';
import { MessageBox } from 'moovila-common';

const GeneralInfo = ({APIVersion, APIURL, siteURL}) => (
  <MessageBox title='General Info' backTo='/home'>
    <div className='row'>
      <div className='col-xs-12 form-group'>
        <label>API Version:</label>
        <span className='pad-left'>{APIVersion}</span>
      </div>
    </div>
    <div className='row'>
      <div className='col-xs-12 form-group'>
        <label>API URL:</label>
        <span className='pad-left'>{APIURL}</span>
      </div>
    </div>
    <div className='row'>
      <div className='col-xs-12 form-group'>
        <label>Site URL:</label>
        <span className='pad-left'>{siteURL}</span>
      </div>
    </div>
  </MessageBox>
);

export default GeneralInfo;



// WEBPACK FOOTER //
// ./src/components/Utilities/GeneralInfo.js